// The current language for code outside React (e.g. translating server error
// messages in api.js). The I18nProvider keeps it up to date.
import ES from './i18n/es';

const DICTIONARIES = { es: ES };
let current = 'en';

export function setCurrentLang(lang) {
  current = lang;
}

export function getCurrentLang() {
  return current;
}

// The locale for dates and times in the current language, e.g. "lunes, 19 de octubre".
export function currentLocale() {
  return current === 'es' ? 'es-419' : 'en-US';
}

export function lookup(lang, text) {
  const dict = DICTIONARIES[lang];
  return dict && dict[text] !== undefined ? dict[text] : text;
}

// Translates now, filling {placeholders} from vars.
export function translateNow(text, vars) {
  const out = lookup(current, text);
  if (!vars) return out;
  return out.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? vars[k] : m));
}
